import { useMutation } from 'react-query';

import { registerNameAndEmail } from '../services';

export const useSignUp = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: registerNameAndEmail,
    onSuccess,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const message = error?.response?.data?.payload?.message;
      let errorText = message || 'Something went wrong...';

      if (message === 'registration/email-already-taken') {
        errorText = 'Email already taken';
      }

      if (message === 'invalid-request-format') {
        errorText = 'Email is not valid';
      }

      onError?.(errorText);
    },
  });
};
